import HTab from './HTab'
import HTag from './HTag'
import HMsg from './HMsg'
import HToolbar from './HToolbar'
import HPaneler from './HPaneler'
import HDataGrid from './HDataGrid'
import HSearchForm from './HSearchForm'
import HVarietyTree from './HVarietyTree'
import Expand from './expand'
import EditPayPassword from './EditPayPassword'

export default {
  EditPayPassword,
  HTab,
  HTag,
  HMsg,
  HToolbar,
  HPaneler,
  HDataGrid,
  HSearchForm,
  HVarietyTree,
  Expand
}
